import axios from "axios";

export default function SubscriptionStartPayService(formData) {

  return axios({
    method: 'post',
    url: process.env.REACT_APP_SUBSCRIPTION_API_HOST + "/start_payment",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
